<template>
  <el-menu
    class="menu-nav"
    router
    background-color="#FFFFFF"
    text-color="#4F4F4F"
    :default-active="menu"
    :default-openeds="['1','2','3','4']"
    :collapse="isCollapse" v-if="userId.indexOf('ofmom-stock')==-1">
    <el-submenu index="1" v-if="dashboardSales == 1 || dashboardSales == 2">
      <template slot="title">
        <i class="el-icon-data-analysis"></i>
        <span slot="title" style="padding-right: 15px;font-size: 20px">数据管理</span>
      </template>
      <el-menu-item index="/ReportDetailPage" v-if="dashboardSales!=0">销售明细（已发放红利）</el-menu-item>
      <el-menu-item index="/ReportDetailUnsettle" v-if="dashboardSales!=0">申报明细（未发放红利）</el-menu-item>
      <!--      <el-menu-item index="" @click="toDataAnalysis" v-if="dashboardSales == 1">数据分析-->
      <!--      </el-menu-item>-->

    </el-submenu>
    <el-submenu index="2"
                v-if="!(dashboardSales != 1 || isAdmin != 1) || (!(stock<1) && !isManagerLogin && dashboardSales != 0) || !(dashboardSales != 1 || package)">
      <template slot="title">
        <i class="el-icon-office-building"></i>
        <span slot="title" style="padding-right: 15px;font-size: 20px">业务管理</span>
      </template>
      <el-menu-item index="/CoreAdmin" v-if="!(dashboardSales != 1 || isAdmin != 1)">全局管理设置
      </el-menu-item>

      <el-menu-item index="/ProductManagement" v-if="!(dashboardSales != 1 || isAdmin != 1)">
        产品管理
      </el-menu-item>
      <el-menu-item index="/Package" data-intro="点击查看/调整提成规则" data-position="right"
                    v-if="!(dashboardSales != 1 || isAdmin != 1)">
        提成规则管理
      </el-menu-item>
      <el-menu-item index="/PurchaseSaleStorage" v-if="!(stock<1) && !isManagerLogin && dashboardSales != 0">进销存管理
      </el-menu-item>
      <el-menu-item index="/RuleReview" v-if="!(dashboardSales != 1 || package)">提成规则审核
      </el-menu-item>
      <el-menu-item index="/ProcessApproval" v-if="!(dashboardSales != 1)">流程审核
      </el-menu-item>

    </el-submenu>
    <el-submenu index="3" v-if="dashboardSales == 1 || dashboardSales == 2">
      <template slot="title">
        <i class="el-icon-user"></i>
        <span slot="title" style="padding-right: 15px;font-size: 20px">人员管理</span>
      </template>
      <el-menu-item index="/ReportDetailPagePurchase" v-if="dashboardSales != 0">导购员名单</el-menu-item>
      <el-menu-item index="/BlockedInfoView" v-if="dashboardSales == 1">冻结名单管理
      </el-menu-item>
      <el-menu-item index="/LabelView" v-if="dashboardSales == 1">自定义标签</el-menu-item>
      <el-menu-item index="/ManagerView" v-if="dashboardSales == 1">导购业务员对接
      </el-menu-item>
      <el-menu-item index="/SupplierInfo" v-if="dashboardSales == 1">业务员权限配置
      </el-menu-item>
      <el-menu-item index="/SalePunchInfo" v-if="dashboardSales == 1">在店打卡明细</el-menu-item>
    </el-submenu>
    <el-submenu index="4"
                v-if="!(dashboardSales != 1 || isAdmin != 1) || !(dashboardSales != 1 || instruction || isAdmin != 1) ">
      <template slot="title">
        <i class="el-icon-money"></i>
        <span slot="title" style="padding-right: 15px;font-size: 20px">财务管理</span>
      </template>
      <el-menu-item index="/ChannelFlowDetails" v-if="!(dashboardSales != 1 || isAdmin != 1)">
        基础账户明细
      </el-menu-item>
      <el-menu-item index="/PackageExplorer" v-if="resourceBundle && !(dashboardSales != 1 || isAdmin != 1)">
        资源包管理
      </el-menu-item>
      <el-menu-item index="/ServiceChargeView" v-if="!(dashboardSales != 1 || isAdmin != 1)">
        服务费账单
      </el-menu-item>
      <el-menu-item index="/ServiceChargeWallet" v-if="!(dashboardSales != 1 || isAdmin != 1)">
        服务费账户明细
      </el-menu-item>
      <el-menu-item index="/InvoiceInfoView" v-if="!(dashboardSales != 1 || isAdmin != 1)">
        发票明细
      </el-menu-item>
      <el-menu-item index="/Instruction" v-if="!(dashboardSales != 1 || isAdmin != 1 || instruction)">资金特发管理
      </el-menu-item>
    </el-submenu>


  </el-menu>
</template>

<script>
import AES from '../../api/AES'
import {toDataAnalysis} from "@/api/dataAnalysis"
import {isOvAdmin} from "@/api/perm"
import {getManager} from '@/api/ReportDetailPage'

export default {
  props: ['isCollapse'],
  mounted() {
    if (this.$route.path !== '/GetPhoneNumber' && this.$route.path !=='/DataUpload')
    this.$intro()
      .setOptions({
        exitOnOverlayClick: false,
        showStepNumbers: false,
        disableInteraction: false,
        showBullets: false,
        // showButtons: false,
        showProgress: false,
        doneLabel: "我知道了"
      })
      .start();
  },
  data() {
    return {
      currentPath: location.pathname,
      dis: true,
      searchs: '',
      instruction: true,
      ChannelFlowDetail: true,
      label: true,
      stock: undefined,
      salesman: false,
      package: false,
      dashboardSales: '',
      isAdmin: '',
      isManagerLogin: false,
      resourceBundle: false,
      userId: ''
    }
  },
  computed: {
    menu() {
      return this.$route.path
    }
  },
  created() {
    this.dashboardSales = localStorage.getItem('dashboardSales')
    this.isAdmin = localStorage.getItem('isAdmin')
    this.stock = localStorage.getItem('stock')
    this.isManagerLogin = localStorage.getItem('managerId') != 'null'
    let bonus_order = localStorage.getItem('bonus_order')
    //资源包显示
    this.resourceBundle = eval(localStorage.getItem('resourceBundle').toLowerCase());
    let {username} = JSON.parse(sessionStorage.getItem('user'))
    this.userId = username
    if (username.indexOf('ofmom-stock') >= 0) {
      this.$router.replace({name: 'PurchaseSaleStorage'})
    }

    // 判断是否有进入特发权限
    if (bonus_order == 1) {
      this.instruction = false
      this.colorInstruction = '#EF6C00'
    }
    // 判断是否有权限进入业务员名单
    this.token = localStorage.getItem('token')
    getManager(this.token).then(res => {
      let {data} = res
      this.salesman = data.date.manager === 0 ? true : false;
      this.package = data.date.package === '0' ? true : false;
    })
  },
  methods: {
    consoles() {
      this.$router.replace({path: '/console'})
    },
    toDataAnalysis() {
      if (this.$route.path != '/DataAnalysis')
        toDataAnalysis()
    },
    selectOvAdmin() {
      let token = localStorage.getItem('token')
      isOvAdmin(token).then(({data}) => this.userPerms = data.date)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-menu {
  border: none;
  min-height: 100%;
  border-right: 1px solid #BEBEBE;
}

.menu-nav:not(.el-menu--collapse) {
  width: 200px;
  min-height: 100%;
  border-right: 1px solid #BEBEBE;
}

</style>
<style>
.introjs-tooltip-header {
  /* display: none; */
  padding: 0 !important;
}
</style>
